import * as React from 'react'
import { Select, Division } from '$views/components'
import { FieldProps } from 'formik'
import { draft } from '$utils/services/formDraftService'
import { ErrorText } from '$views/components/Input'

interface Props {
  draftName: string
  list: { label: string; value: string }[]
}

export const ResidentField: React.FC<Props & FieldProps<any>> = ({ draftName, list, form, field }) => {
  const changeFieldValues = (event, fieldName) => {
    form.setValues({ ...form.values, [fieldName]: event.value })
    draft.set(draftName, { [fieldName]: { id: event.value, name: event.label } })
  }

  const selectDefault = (fieldName: string) => {
    if (form.values[fieldName]) {
      const selectedResident = list.find(resident => resident.value === form.values[fieldName])
      return selectedResident
    }
    return ''
  }

  return (
    <>
      <Select
        onChange={event => changeFieldValues(event, field.name)}
        placeholder={'Ningún residente seleccionado'}
        defaultOption={selectDefault(field.name)}
        name={field.name}
        options={list}
      />
      {form.errors[field.name] && (
        <>
          <ErrorText as="p" caption error>
            {form.errors[field.name]}
          </ErrorText>
          <Division marginTop="base" color="darkPink" />
        </>
      )}
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/ResidenceForm/ResidentStep/components/ResidentField.tsx